<!--
 * @ Author: Clark
 * @ Create Time: 2023-02-05 20:20:57
 * @ Modified by: Your name
 * @ Modified time: 2023-03-03 11:00:55
 * @ Description: 司机管理>平台内部司机>子公司管理新增/编辑
 -->

<template>
  <ykc-form :model="ruleForm" :rules="rules" ref="ruleForm" class="el-form-wrap">
    <ykc-form-item label="子公司名称" prop="name">
      <ykc-input
        v-model="ruleForm.name"
        :placeholder="'中文、英文、数字（1~30字数），不可重复'"></ykc-input>
    </ykc-form-item>
    <ykc-form-item :label="'上级公司'" prop="parentId">
      <ykc-dropdown
        :remote="true"
        :disabled="isEdit"
        v-model="ruleForm.parentId"
        placeholder="请输入机构关键字"
        :isObject="true"
        :configSet="configSet"
        :searchMaxLength="1000"
        @change="handleSelectMainOrg"
        :data="mainOrgList || []"></ykc-dropdown>
    </ykc-form-item>
    <ykc-form-item label="管理员" prop="manageName">
      <ykc-input v-model="ruleForm.manageName" :placeholder="'请输入管理员姓名'"></ykc-input>
    </ykc-form-item>
    <ykc-form-item label="联系方式" prop="contactInfo">
      <ykc-input
        v-model="ruleForm.contactInfo"
        maxlength="11"
        :placeholder="'请输入机构管理员联系方式'"></ykc-input>
    </ykc-form-item>
    <ykc-form-item
      class="img-error"
      label="统一社会信用代码"
      bottomTip="温馨提示：请认真核对营业执照上的18位编码"
      prop="socialCreditCode">
      <ykc-input
        v-model="ruleForm.socialCreditCode"
        maxlength="18"
        :placeholder="'请输入统一社会信用代码'"></ykc-input>
    </ykc-form-item>
  </ykc-form>
</template>

<script>
  import regexpObj from '@/utils/regexp';
  import { customerOrg } from '@/service/apis';

  export default {
    props: {
      id: {
        type: String,
      },
      isEdit: {
        type: Boolean,
        default: false,
      },
      isAddChildren: {
        type: Boolean,
      },
    },
    components: {},
    data() {
      return {
        // 机构下拉框数据显示配置
        configSet: {
          label: 'name',
          value: 'id',
        },
        name: '',
        socialCreditCode: '',
        mainOrgList: [],
        ruleForm: {
          id: '',
          name: '',
          parentId: '',
          mainOrgId: '',
          manageName: '',
          contactInfo: '',
          socialCreditCode: '',
        },
        rules: {
          name: [
            { required: true, message: '请输入子公司名称', trigger: 'blur' },
            { validator: this.onlyCheckName, trigger: 'blur' },
          ],
          parentId: [{ required: false, message: '请选择上级公司', trigger: 'blur' }],
          manageName: [{ required: true, message: '请输入管理员姓名', trigger: 'blur' }],
          socialCreditCode: [
            { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.creditCode.regexp,
              message: regexpObj.regexp.input.creditCode.errorTips.error('统一社会信用代码'),
            },
            { validator: this.onlyCheckCreditCode, trigger: 'blur' },
          ],
          contactInfo: [
            { required: true, message: '请输入联系方式', trigger: 'blur' },
            {
              trigger: 'blur',
              pattern: regexpObj.regexp.input.cellphoneType.regexp,
              message: regexpObj.regexp.input.cellphoneType.errorTips.error('联系方式'),
            },
          ],
        },
      };
    },
    watch: {
      // eslint-disable-next-line func-names
    },
    computed: {
      formData() {
        console.log(JSON.stringify(this.ruleForm));
        const formData = {
          // 机构名称 主机构 公司名称 统一社会信用代码 管理员 联系方式  新增种类
          id: this.ruleForm.id,
          name: this.ruleForm.name,
          parentId: this.ruleForm.parentId,
          socialCreditCode: this.ruleForm.socialCreditCode,
          manageName: this.ruleForm.manageName,
          contactInfo: this.ruleForm.contactInfo,
          mainOrgId: this.ruleForm.mainOrgId,
          orgMold: 2, // 1主机构 2子机构
        };
        return formData;
      },
    },
    created() {
      this.queryCompanyAllOrgList();

      // 获取机构数据数据
      Promise.all([customerOrg.detail({ id: this.id })]).then(([powerStation]) => {
        this.powerStationList = powerStation;
      });
      if (this.isEdit) {
        customerOrg
          .detail({
            id: this.id,
          })
          .then(res => {
            this.ruleForm = {
              orgMold: this.isAddChildren ? 2 : 1, // 1主机构 2子机构
              ...res,
            };
            if (res.parentId === 0) {
              this.ruleForm.parentId = null;
            }
            this.name = res.name;
            this.socialCreditCode = res.socialCreditCode;
          });
      }
    },
    methods: {
      // 获取机构下拉数据
      queryCompanyAllOrgList() {
        customerOrg.queryCompanyAllOrgList({}).then(res => {
          this.mainOrgList = res;
        });
      },
      handleSelectMainOrg(e) {
        console.log(e);
        this.ruleForm.parentId = e.id;
        this.ruleForm.mainOrgId = e.mainOrgId;
        console.log(this.ruleForm.mainOrgId >= 0);
      },

      /**
       * 名称唯一性校验
       */
      onlyCheckName(rule, value, callback) {
        if (value) {
          customerOrg
            .checkOrgRepeat({ name: value })
            .then(res => {
              if (res && this.ruleForm.name !== this.name) {
                callback(new Error('名称重复'));
              } else {
                callback();
              }
            })
            .catch(() => {});
        }
      },
      /**
       * 统一社会信用代码唯一性校验
       */
      onlyCheckCreditCode(rule, value, callback) {
        if (value) {
          customerOrg
            .checkOrgRepeat({ socialCreditCode: value })
            .then(res => {
              if (res && this.ruleForm.socialCreditCode !== this.socialCreditCode) {
                callback(new Error('该统一社会信用代码已经被占用'));
              } else {
                this.nameValidError = '';
                callback();
              }
            })
            .catch(() => {});
        }
      },
      submitForm() {
        return new Promise(resolve => {
          this.validateForm().then(() => {
            if (this.isEdit) {
              customerOrg.edit(this.formData).then(() => {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                });
                resolve();
              });
            } else {
              customerOrg.add(this.formData).then(() => {
                this.$message({
                  message: '保存成功',
                  type: 'success',
                });
                resolve();
              });
            }
          });
        });
      },
      validateForm() {
        return new Promise((resolve, reject) => {
          this.$refs.ruleForm.validate(valid => {
            if (valid) {
              resolve();
            } else {
              reject();
            }
          });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  ._line {
    display: flex;
    & > * {
      margin-right: 5px;
    }
  }
</style>
